(() => {
  'use strict';
  const STORAGE_KEY = 'dnaskate_ad_attribution_v1';
  const PARAMS = ['gclid', 'gbraid', 'wbraid', 'utm_source', 'utm_medium', 'utm_campaign', 'utm_id', 'utm_term', 'utm_content'];
  const FIELDS = [...PARAMS, 'landing_page', 'captured_at'];
  const clean = value => typeof value === 'string' ? value.trim().slice(0, 250) : '';
  const allowed = () => window.Shopify?.customerPrivacy?.marketingAllowed?.() === true;
  const denied = () => window.Shopify?.customerPrivacy?.currentVisitorConsent?.().marketing === 'no';
  const root = () => window.Shopify?.routes?.root || '/';
  let queue = Promise.resolve();
  let subscribed = false;
  let captured = false;
  const forget = () => {
    try { localStorage.removeItem(STORAGE_KEY); } catch {}
  };
  const readStored = () => {
    if (!allowed()) return {};
    try {
      const value = JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}');
      if (!value || value.version !== 2 || !Number.isFinite(value.updatedAt) || Date.now() - value.updatedAt > 7776000000 || value.updatedAt > Date.now()) return {};
      return value;
    } catch { return {}; }
  };
  const capture = () => {
    if (!allowed() || captured) return;
    captured = true;
    const query = new URLSearchParams(window.location.search);
    const touch = {};
    for (const name of PARAMS) {
      const value = clean(query.get(name));
      if (value) touch[name] = value;
    }
    if (!Object.keys(touch).length) return;
    touch.landing_page = clean(window.location.pathname + window.location.search);
    touch.captured_at = new Date().toISOString();
    const next = { version: 2, first: readStored().first || touch, last: touch, updatedAt: Date.now() };
    if (allowed()) {
      try { localStorage.setItem(STORAGE_KEY, JSON.stringify(next)); } catch {}
    }
  };
  const attributes = stored => {
    const result = {};
    for (const position of ['first', 'last']) {
      for (const name of FIELDS) {
        result[`_dnaskate_${position}_${name}`] = clean(stored[position]?.[name]);
      }
    }
    return result;
  };
  const sync = () => {
    queue = queue.then(async () => {
      const permitted = allowed();
      if (!permitted && !denied()) return;
      const stored = permitted ? readStored() : {};
      if (permitted && !stored.first && !stored.last) return;
      const response = await fetch(root() + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } });
      if (!response.ok) return;
      const cart = await response.json();
      if (permitted !== allowed() || (!permitted && !denied())) return;
      const values = attributes(stored);
      if (permitted && !cart.item_count) return;
      if (Object.entries(values).every(([key, value]) => (cart.attributes?.[key] || '') === value)) return;
      await fetch(root() + 'cart/update.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: values })
      });
    }).catch(() => {});
    return queue;
  };
  const subscribeCart = () => {
    if (!subscribed && typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, () => sync());
      subscribed = true;
    }
  };
  const applyConsent = () => {
    if (denied()) { captured = false; forget(); }
    if (allowed()) capture();
    sync();
  };
  document.addEventListener('visitorConsentCollected', applyConsent);
  document.addEventListener('cart:updated', () => sync());
  document.addEventListener('cartUpdate', () => sync());
  document.addEventListener('submit', event => {
    const form = event.target;
    if (form instanceof HTMLFormElement && /\/cart\/add(?:\.js)?$/.test(new URL(form.action, location.href).pathname)) {
      window.setTimeout(() => sync(), 750);
    }
  });
  const start = () => {
    subscribeCart();
    if (window.Shopify?.customerPrivacy) applyConsent();
    else window.Shopify?.loadFeatures?.([{ name: 'consent-tracking-api', version: '0.1' }], error => {
      if (!error) applyConsent();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
  window.addEventListener('load', subscribeCart, { once: true });
})();
